import { CrossingCountryViewModel } from "../../../../../ViewModel/CrossingCountryViewModel";
import { FtlRouteViewModel } from "../../../../../ViewModel/FtlRouteViewModel";
import { getCrossingCountriesFromRoutingGrid } from "./GetCrossingCountriesFromRoutingGrid";

export const isCountryRemovable = (
  dataItem: CrossingCountryViewModel,
  ftlRoute: FtlRouteViewModel | undefined
) => {
  if (!dataItem || !dataItem.Name) {
    return true;
  }

  if (!ftlRoute || !ftlRoute.RoutingTable) {
    return true;
  }

  return getCrossingCountriesFromRoutingGrid(ftlRoute).includes(dataItem.Name);
};
